import { BodyText, Introduction, styled } from '@lessonup/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FullPageBodySection,
  FullPageBodySectionTransparent,
} from '../../../../../components/FullPageFlow/FullPageBodySection';
import { GeneratedResultProps } from '../../../../../components/GeneratedResult/GeneratedResult';
import { GeneratedPins } from './components/GeneratedPins/GeneratedPins';
import { GeneratedPinItemProps } from './components/GeneratedPins/components/GeneratedPinItem';

export type GeneratedResultItem = Omit<GeneratedResultProps, 'selected'>;

export interface LessonReviewStepProps {
  generatedPins: GeneratedPinItemProps[];
  lessonName?: string;
  optOut?: boolean;
  isCompleted: boolean;
}

export const LessonReviewStep = ({ generatedPins, optOut, isCompleted }: LessonReviewStepProps) => {
  const { t } = useTranslation('chatGPT');

  return (
    <>
      <FullPageBodySectionTransparent>
        <Introduction
          alignment="center"
          size="M"
          headline={t('reviewSlides.title')}
          bodyText={t('reviewSlides.subTitle')}
        />
      </FullPageBodySectionTransparent>

      <StyledMainContentSection>
        <StyledBodyText weight="bold">{t('reviewSlides.reviewMainLabel')}</StyledBodyText>
        <GeneratedPins generatedPins={generatedPins} optOut={optOut} isCompleted={isCompleted} />
      </StyledMainContentSection>
    </>
  );
};

const StyledBodyText = styled(BodyText)`
  align-self: start;
`;

const StyledMainContentSection = styled(FullPageBodySection)`
  align-items: stretch;
  overflow: hidden;
`;
